export const cards = [
  {
    title: 'Образовательные программы аспирантуры в области МО и КТ',
    list: [
      'Прикладные технологии искусственного интеллекта;',
      'Машинное обучение и искусственный интеллект;',
      'Биометрические информационные системы;',
      'Речевые информационные системы;',
      'Когнитивные вычисления и квантовый интеллект;',
      'Большие данные и экстренные вычисления;',
      'Семантические системы и инженерия знаний;',
      'Технологии разработки компьютерных игр'
    ],
    slide: require('../images/education-slide1.jpg')
  },
  {
    title: 'Образовательные программы аспирантуры в области МО и КТ',
    list: [
      'Прикладные технологии искусственного интеллекта;',
      'Машинное обучение и искусственный интеллект;',
      'Биометрические информационные системы;',
      'Речевые информационные системы;',
      'Когнитивные вычисления и квантовый интеллект;',
      'Большие данные и экстренные вычисления;',
      'Семантические системы и инженерия знаний;',
      'Технологии разработки компьютерных игр'
    ],
    slide: require('../images/education-slide2.jpg')
  }
];